import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from '../components/HeroSection.js';
import FeaturesSection from '../components/FeaturesSection.js';
import CourseCard from '../components/CourseCard.js';
import ContactSection from '../components/ContactSection.js';

const HomePage = () => {
  const coursesRef = useRef(null);
  const location = useLocation();

  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}/courses`);
        if (!response.ok) throw new Error(`Lỗi HTTP! Trạng thái: ${response.status}`);
        const data = await response.json();
        setCourses(data);
      } catch (err) {
        console.error('Lỗi khi fetch khóa học:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [API_BASE_URL]);

  useEffect(() => {
    // Cuộn đến phần "courses" nếu URL có hash "#courses"
    if (location.hash === '#courses' && coursesRef.current) {
      setTimeout(() => {
        coursesRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 200); // Chờ render xong rồi mới cuộn
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return (
    <>
      <HeroSection />
      <FeaturesSection />
      <div className="container mx-auto pb-4">
        <h2
          ref={coursesRef}
          id="courses"
          className="text-4xl font-extrabold text-gray-900 text-center mb-10 leading-tight"
        >
          Nội Dung Nổi Bật
        </h2>

        {loading ? (
          <div className="text-center py-10">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-purple-500 mx-auto mb-4"></div>
            <p className="text-xl text-gray-700">Đang tải khóa học...</p>
          </div>
        ) : error ? (
          <div className="text-center py-10">
            <p className="text-xl text-red-600">Lỗi: {error}</p>
            <p className="text-gray-600 mt-2">Vui lòng thử lại sau hoặc kiểm tra kết nối backend của bạn.</p>
          </div>
        ) : courses.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {courses.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
        ) : (
          <div className="col-span-full text-center text-gray-600 text-lg py-10">
            Chưa có khóa học nào được tìm thấy.
          </div>
        )}
      </div>
      <ContactSection />
    </>
  );
};

export default HomePage;
